export class ReferData {
    mobile: string = '';
    prospectId: string = '';
    rmId: string = '';
    product: string = '';
    email: string = '';
    name: string = '';
    company: string = '';
    location: string = '';
    designation: string = '';
    comment: string = '';
    partnerId: string = '';
    channel: string = '';
    leadSource: string = '';
    googleClickID: string = '';
    couponCode: string = '';

    constructor() {
    }
}